import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import logo from "../images/logo.svg";

function Navigation() {
  
  const [showNav, setShowNav] = useState(false);

  const toggleNav = () => {
    setShowNav(!showNav);
  };

  return (
    <div className="navigation">
      <nav className={`navbar navbar-expand-lg ${showNav ? 'navbar-dark nav-open-bg' : 'navbar-light bg-light'}`}>
        <div className="container">
          <NavLink className="navbar-brand color-1" to="/">
            <img src={logo} alt="Teleflex" height={40} />
          </NavLink>

          <button className="navbar-toggler" type="button" onClick={toggleNav}>
            <span className={`navbar-toggler-icon ${showNav ? 'icon-open' : ''}`}></span>
          </button>
          
          <div className={`collapse navbar-collapse ${showNav ? 'show' : ''}`}>
            <ul className="navbar-nav ml-auto all-caps compatil-reg">
              <li className="nav-item">
                <NavLink className="nav-link" to="/provider">
                  Provider
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/nurse-technician">
                  Nurse/Technician
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/supply-chain">
                  Supply Chain
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navigation;
